@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.container {
  background-color: $white;
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 2;
  padding-left: 24px;

  .header {
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: 16px 24px;

    .headerContent {
      align-items: center;
      display: flex;
    }

    .breadcrumbs {
      align-items: center;
      display: flex;
      margin-left: 24px;

      .breadcrumb + .breadcrumb {
        margin-left: 18px;
      }

      .breadcrumb {
        color: $gray-40;
        fill: $gray-40;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
      }

      .breadcrumb.active {
        color: $black;
      }
    }

    .closeButton {
      height: 24px;
      svg {
        fill: $almanac-black;
      }
    }
  }

  .body {
    padding-top: 32px;
  }
}

.frameHeader {
  @include header-md;
  margin-left: 20px;

  color: $gray-90;
}

.frame {
  @include fadein(0.8s);

  display: flex;
  justify-content: space-between;
  min-height: 512px;
  position: relative;

  &:not(.handbookSetting) {
    margin-left: 20px;
  }

  @include for-phone-only {
    flex-direction: column;
  }

  .publishingFrameHeader {
    @extend .frameHeader;

    display: flex;
    justify-content: center;
    text-align: center;
    width: 100%;

    .publishingFrameHeaderText {
      max-width: 320px;
    }

    svg {
      margin-right: 16px;
    }
  }

  .frameNavButtons {
    align-items: center;
    display: flex;
    margin-top: 38px;

    > * + * {
      margin-left: 8px;
    }

    .frameNavButton {
      font-weight: 500;
      font-size: 12px;
      height: 28px;
      line-height: 16px;
      min-width: 80px;
      padding: 6px 8px;
    }

    .whiteButton {
      @extend .frameNavButton;

      border: 1px solid $gray-30;

      &:hover {
        border-color: $gray-40;
      }
    }
  }

  .leftColumn {
    width: 48%;
    padding-right: 20px;

    @include for-phone-only {
      width: initial;
      padding: 0;
    }

    .frameHeader {
      margin-left: 0;
    }

    .subtitle {
      @include body-sm-text;

      color: $gray-90;
      margin-bottom: 16px;
    }

    .linkText {
      @include body-sm-text;

      cursor: pointer;
    }

    .whiteButton {
      @extend .frameNavButton;

      border: 1px solid $gray-30;

      &:hover {
        border-color: $gray-40;
      }
    }

    .linkTextWithMargin {
      @extend .linkText;

      display: block;
      margin-bottom: 10px;
      max-width: 90%;
    }

    .textContainer {
      width: 100%;

      .boldText {
        color: $gray-90;
        font-weight: bold;
        font-size: 14px;
        line-height: 16px;
        margin-bottom: 10px;
      }

      .exampleUrlText {
        color: $gray-40;
        font-weight: 500;
        font-size: 12px;
        line-height: 20px;
      }
    }

    .divider {
      border-bottom: 1px solid $gray-20;
      margin: 36px 0 8px;
    }

    .linkTextContainer {
      align-items: flex-start;
      display: flex;

      svg {
        fill: $gray-40;
        margin-right: 10px;
        margin-top: -3px;
      }
    }

    .form {
      margin-top: 32px;

      .resetButton {
        @include body-xs-text;

        color: $blue-50;
        font-weight: 500;
        margin-top: 8px;
        width: fit-content;

        &:hover {
          cursor: pointer;
          text-decoration: underline;
        }
      }

      .formText {
        @include body-sm-text;

        color: $gray-90;
      }

      .uploadContainer {
        align-items: center;
        border: 1px solid $gray-30;
        border-radius: 4px;
        display: flex;
        justify-content: space-between;
        margin-left: 26px;
        margin-top: 12px;
        padding: 8px 12px 8px 8px;
        position: relative;

        &:focus-within {
          border-color: var(--action-50);
        }

        &.dragActive {
          border: 2px solid $blue-50;
          margin: 11px -1px -1px;
        }

        .uploadTextContainer {
          align-items: center;
          display: flex;
          width: 80%;

          .uploadText {
            @include body-sm-text;

            margin-left: 8px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 90%;

            input {
              bottom: 0;
              left: 0;
              position: absolute;
              right: 0;
              top: 0;
            }
          }
        }

        .limitText {
          @include body-xs-text;

          color: $gray-40;
        }

        .removeText {
          @include body-xs-text;

          color: $gray-40;
          cursor: pointer;

          &:hover {
            color: $gray-90;
          }
        }

        .hide {
          display: none;
        }
      }

      .uploadContainer.error {
        background-color: $red-5;
        border-color: $red-50;
      }

      .errorMessage {
        @include ui-sm-text;

        color: $red-50;
        margin-top: 8px;
        padding-bottom: 32px;
      }

      .helpText {
        @include body-xs-text;

        color: $gray-40;
        margin-left: 26px;
        margin-top: 12px;
      }

      .formField {
        width: 100%;

        .radioInput {
          align-items: center;
          cursor: pointer;
          display: flex;
          margin-top: 32px;

          > * + * {
            margin-left: 10px;
          }

          svg {
            min-width: 16px;

            g {
              filter: none;
            }
          }

          .radioLabel {
            align-items: center;
            color: $almanac-black;
            display: flex;
            font-size: 14px;
            line-height: 16px;

            > * + * {
              margin-left: 10px;
            }
          }
        }

        .radioInput.topAlignRadioInput {
          align-items: flex-start;

          svg {
            margin-top: 4px;
          }
        }
      }

      .textInput {
        border: 1px solid $gray-30;
        border-radius: 4px;
        color: $almanac-black;
        font-size: 14px;
        line-height: 16px;
        margin-top: 8px;
        padding: 12px;
        transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;

        > * {
          transition: background-color 0.2s ease-in-out;
        }

        &:focus-within {
          border-color: var(--action-50);
        }
      }

      .urlInputStatic {
        @extend .textInput;

        color: $gray-50;
      }

      .urlInput {
        @extend .urlInputStatic;

        display: flex;

        input {
          color: $almanac-black;
          width: 100%;
        }
      }

      .textInput.error {
        background-color: $red-5;
        border-color: $red-50;
        color: $red-50;

        > * {
          background-color: $red-5;
        }
      }

      .errorText {
        @include ui-sm-text;

        color: $red-50;
        margin-top: 8px;
      }
    }
  }

  .rightColumn {
    width: 48%;
    display: flex;
    overflow: hidden;
    flex: 1;
    justify-content: flex-end;
    position: relative;

    @include for-phone-only {
      width: 100%;
      height: 512px;
      flex: initial;
    }

    .image {
      box-shadow: $shadow-s3;
      position: absolute;
      bottom: 0;
      height: 470px;
      right: 0;
      width: 100%;
    }
  }
}

.domainCalloutContainer {
  margin-top: 32px;

  .domainCallout {
    background-color: $gray-5;
    border-radius: 8px;
    padding: 12px 12px 18px;
    width: 100%;

    .title {
      @include header-xs;

      color: $gray-90;
    }

    .urlOptions {
      @include body-xs-text;

      color: $gray-40;
      margin-top: 8px;
    }

    .domainCalloutLink {
      @include btn-sm-text;

      align-items: center;
      background-color: $white;
      border: 1px solid $gray-30;
      border-radius: 4px;
      color: $almanac-black;
      display: flex;
      margin-top: 16px;
      padding: 6px 8px;
      width: fit-content;

      svg {
        fill: $gray-40;
        margin-left: 8px;
      }

      &:hover {
        background-color: $gray-5;
      }

      &:active {
        background-color: $gray-10;
      }
    }
  }
}

.preview {
  align-items: center;
  border-radius: 8px;
  display: flex;
  font-weight: 500;
  line-height: 16px;
  padding: 0 5px;
  position: absolute;

  > * + * {
    margin-left: 3px;
  }

  svg {
    height: 8px;
    width: 8px;
  }
}

.previewSidebar {
  @extend .preview;

  background-color: $white;
  color: $gray-20;
  font-size: 6px;
  left: 3px;
  top: 25%;

  .previewText {
    color: $gray-90;
    max-width: 90px;
  }
}

.previewUrl {
  @extend .preview;
  @include line-clamp;

  background-color: $gray-10;
  color: $gray-90;
  display: block;
  font-size: 8px;
  left: 100px;
  line-height: 100%;
  padding: 4px;
  width: 100%;
  top: 76px;
  z-index: 2;
}

.previewUrl.active {
  @include bgColorFlashBetween($gold-30, $gray-10);
  @include blur(6px);
}

.previewSidebar.active {
  @include bgColorFlashBetween($gold-30, $white);
  @include blur(6px);
}

.previewLogo {
  @extend .preview;

  border-radius: 0;
  color: $almanac-black;
  font-size: 8px;
  left: 8%;
  top: 19.5%;
  max-height: 17px;

  border-radius: 2px;

  &.customLogo {
    padding: 2px;

    img {
      height: 13px;
      width: 58px;
    }
  }
}

.previewText {
  @include line-clamp;
  max-width: 96px;
}

.previewLogo.defaultLogo {
  border-radius: 4px;
  left: 0;
  top: 19.5%;
}

.previewLogo.active {
  @include bgColorFlashBetween($gold-30, $white);
  @include blur(6px);

  .previewText {
    @include colorFlashBetween($gray-90, $gray-20);
  }
}

.previewNavTitle {
  @extend .preview;

  color: $gray-90;
  font-size: 7px;
  left: 10%;
  top: 10.5%;

  img {
    height: 12px;
  }

  .previewText {
    border-radius: 4px;
    max-width: 100px;
    min-width: 100px;
  }
}

.previewNavTitle.active {
  @include bgColorFlashBetween($gold-30, $white);
  @include blur(6px);
}

.previewTitle {
  @extend .preview;

  color: black;
  font-size: 8px;
  left: 39%;
  top: 19.5%;

  .previewText {
    max-width: 250px;
  }
}

.previewTitle.active {
  @include bgColorFlashBetween($gold-30, $white);
  @include blur(6px);
}

.publishImage {
  bottom: -50px;
  box-shadow: $shadow-s3;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 730px;
}

.frame.publishingFrame {
  overflow: hidden;
  flex-direction: column;

  .previewUrl {
    left: 150px;
    top: 126px;
    width: fit-content;
  }

  .previewNavTitle {
    left: 118px;
    top: 104px;
  }

  .previewTitle {
    left: 220px;
    top: 150px;
  }

  .previewLogo {
    left: 79px;
    top: 147px;
  }

  .previewLogo.defaultLogo {
    left: 88px;
    top: 150px;
  }

  .previewSidebar {
    left: 90px;
    top: 180px;
  }
}

.frame.permissionForm {
  flex-direction: column;
  justify-content: initial;
  max-height: 512px;
  padding-left: 0;

  .permissionFormBody {
    overflow-y: scroll;
    padding: 0 24px 70px;
  }

  .footer {
    background-color: $white;
    bottom: 0;
    box-shadow: inset 0px 1px 0px rgba(19, 21, 26, 0.12);
    left: 0;
    padding: 24px;
    right: 0;
    position: absolute;
  }

  .frameHeader {
    max-width: 70%;
  }

  .frameNavButtons {
    margin-top: 0;
  }

  .alert {
    margin-top: 32px;
  }

  .docTable {
    padding-bottom: 16px;

    .docTableSecondColumn {
      min-width: 124px;
      text-align: left;
    }

    .tableRow {
      @include ui-sm-text;

      align-items: center;
      display: flex;
      justify-content: space-between;
      margin-left: 36px;
      margin-top: 8px;
      padding: 12px;

      .titleContents {
        @include ui-md-text;

        align-items: center;
        color: $gray-90;
        display: flex;
      }

      .icon {
        height: 16px;
        margin-right: 10px;
        width: 16px;

        svg {
          height: 16px;
          width: 16px;
        }
      }

      .docIcon {
        @extend .icon;

        svg {
          fill: $blue-40;
        }
      }

      .emoji {
        margin-right: 10px;
        width: 16px;
      }

      .handbookIcon {
        @extend .icon;

        svg {
          fill: $gold-50;
        }
      }

      .alertIcon {
        @extend .icon;

        margin-right: 20px;

        svg {
          fill: $red-50;
        }
      }
    }

    .docTableHeader {
      @extend .tableRow;

      color: $gray-40;
      font-weight: 500;
      font-size: 10px;
      line-height: 16px;
      letter-spacing: 0.06em;
      text-transform: uppercase;
    }

    .editArticle {
      @extend .tableRow;

      color: $gray-90;
      margin-left: 36px;
    }

    .nonEditArticle {
      @extend .tableRow;

      color: $gray-40;
      margin-left: 0;
    }
  }
}

.cropperOuterWrapper {
  background-color: #c4c4c4;
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1100;
}

.cropBorder {
  background-color: $white;
  border: 1px solid $white;
  opacity: 0.5;
  z-index: 1;
}

.cropperWrapper {
  height: 300px;
  position: relative;
  width: 100%;
}

.cropperContainer {
  img {
    max-width: initial;
    max-height: initial;
  }
}

.cropControls {
  @include shadow-3;

  background-color: $white;
  border-radius: 12px;
  left: 50%;
  padding: 12px 24px;
  position: fixed;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 500px;
  z-index: 1200;

  .sliderRow {
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-top: 12px;

    .zoomSlider {
      margin: 0 10px;
      width: 400px;
    }
  }

  .buttonContainer {
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-top: 32px;

    .cancelCropButton {
      @include btn-lg-text;

      color: $gray-60;
    }

    .saveCropButton {
      min-width: 110px;
    }
  }

  :global {
    .ant-slider-rail {
      background-color: $gray-10;
      height: 8px;
    }

    .ant-slider:hover {
      .ant-slider-track {
        background-color: $blue-50;
      }

      .ant-slider-handle {
        border-color: $blue-50;
      }
    }

    .ant-slider-track {
      background-color: $blue-50;
      height: 8px;
    }

    .ant-slider-handle {
      background-color: $blue-50;
      border: solid 2px $blue-50;
      height: 29px;
      top: -2px;
      width: 29px;

      &:hover {
        background-color: $blue-50;
      }

      &:focus {
        box-shadow: none;
      }
    }
  }
}

.zoomContainer {
  @include inter-medium;

  align-content: center;
  color: $gray-40;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  padding: 24px 18px 20px;
  text-align: center;
}

.zoomTitle {
  color: $gray-80;
  font-weight: bold;
  font-size: 18px;
  line-height: 16px;
}

.zoomHelpText {
  color: $gray-40;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  margin-top: 8px;
}

.zoomLabel {
  @extend .zoomHelpText;
  font-size: 14px;
  margin-top: 20px;
}

.initialScreen {
  flex-grow: 1;
  text-align: center;

  .header {
    @include header-md;

    color: $gray-90;
    margin-top: 30px;
  }

  .publishedHeader {
    @extend .header;

    margin-top: 36px;
  }

  .unpublishHeader {
    @extend .header;

    margin-top: 36px;
  }

  .unpublishSubheader {
    @include body-md-text;

    color: $gray-90;
    margin-top: 16px;
  }

  .updateLinkContainer {
    display: flex;
    justify-content: center;

    .updateLink {
      align-items: center;
      border-radius: 4px;
      color: $blue-50;
      cursor: pointer;
      display: flex;
      font-weight: 500;
      font-size: 12px;
      letter-spacing: 0.01em;
      line-height: 137%;
      padding: 6px 8px;
      text-align: center;
      width: fit-content;

      &:hover {
        background: rgba(19, 21, 26, 0.05);
      }

      svg {
        fill: $blue-50;
        margin-right: 8px;

        &:hover {
          fill: $blue-70;
        }
      }
    }
  }

  .date {
    @include body-sm-text;

    color: $gray-90;
    margin-bottom: 16px;
  }

  .subheader {
    @include body-sm-text;

    color: $gray-40;
    margin: 32px auto 0;
    max-width: 410px;
  }

  .publishedSubheader {
    @extend .subheader;

    margin: 16px auto 0;
  }

  .image {
    bottom: 0;
    box-shadow: 0px 1px 1px rgba(19, 21, 26, 0.12), 0px 8px 24px rgba(19, 21, 26, 0.12);
    left: calc(50% + 128px);
    position: absolute;
    transform: translateX(-50%);
    width: 512px;
  }

  .imageShiftedUp {
    @extend .image;

    bottom: 50px;
  }

  .button {
    @include btn-md-text;

    height: 36px;
    padding: 8px 12px;

    svg {
      fill: $white;
      height: 16px;
      margin-left: 8px;
      width: 16px;
    }
  }

  .greenButton {
    @extend .button;

    &:hover {
      background: linear-gradient(0deg, rgba(19, 21, 26, 0.1), rgba(19, 21, 26, 0.1)), var(--action-50);
      border-color: var(--action-60);
      box-shadow: 0px 1px 0px rgba(19, 21, 26, 0.12);
    }
  }

  .startButton {
    @extend .button;

    min-width: 160px;
  }

  .buttonContainer {
    align-items: center;
    display: flex;
    justify-content: center;
    margin-top: 32px;

    > * + * {
      margin-left: 8px;
    }

    .whiteButton {
      @extend .button;

      border: 1px solid $gray-10;
      box-shadow: 0px 2px 3px #f7f8f9;

      &:hover {
        background: linear-gradient(0deg, rgba(19, 21, 26, 0.05), rgba(19, 21, 26, 0.05)), #ffffff;
        border-color: #dfe1e6;
        box-shadow: 0px 2px 3px #f7f8f9;
      }
    }
  }

  .buttonContainerCompact {
    @extend .buttonContainer;

    margin-top: 24px;
  }

  .footerBanner {
    background-color: $white;
    bottom: 0;
    box-shadow: inset 0px 1px 0px rgba(19, 21, 26, 0.12);
    border-bottom-right-radius: 12px;
    position: absolute;
    right: 0;
    width: 632px;
    z-index: 1;

    .footer {
      @include ui-sm-text;

      align-items: center;
      color: $gray-40;
      display: flex;
      font-weight: 500;
      justify-content: space-between;
      padding: 16px 24px;
    }
  }
}

.unpublishScreen {
  @extend .initialScreen;

  margin: 100px auto 0;
  max-width: 420px;
}

.centerContent {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 488px;
}
